// tabs types
const MagicLinkMethods = {
    Email: 'emailMagicLinks'
};
const PasswordMethods = {
    Email: 'passwords'
};

export { MagicLinkMethods, PasswordMethods };
//# sourceMappingURL=StytchProduct.mjs.map
